import React from "react"
import { CreateMembershipTierForm } from "@/components/forms"
import type { CreateMembershipTierStepProps } from "./CreateMembershipTierStep.types"

export const CreateMembershipTierStep: React.FunctionComponent<
  CreateMembershipTierStepProps
> = ({ onSuccess }) => {
  return <CreateMembershipTierForm onSuccess={onSuccess} />
}
